import React, { useState } from "react";
import styles from './TroubleMessage.module.scss'
import { INSTANCE } from "../../server-parameters";
import { Lang } from "../../types/common-types";
import AccountForm from "../../types/account-form.types";
import PhoneIcon from '../../images/social/phone.svg'
import WhatsappIcon from '../../images/social/whatsapp.svg'
import TgIcon from '../../images/social/tg.svg'

interface TroubleMessageProps {
    lang: Lang
    accountForm: AccountForm
}
export default function TroubleMessage({ lang, accountForm }: TroubleMessageProps) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    return <>
        {
            INSTANCE === 'ala' ?
                <p className={styles.troubleMessage}>
                    {accountForm.troubleContactsMessageText[lang]}{' '}
                    <a onClick={(e) => { e.preventDefault(); toggleExpand(); }}>{accountForm.troubleContactsMessageLink[lang]}</a>
                </p> :
                INSTANCE === 'msk' ?
                    <p className={styles.troubleMessage}>
                        {accountForm.troubleContactsMessageText[lang]}{' '}
                        <a onClick={(e) => { e.preventDefault(); toggleExpand(); }}>{accountForm.troubleContactsMessageLink[lang]}</a>
                    </p> :
                    <p className={styles.troubleMessage}>
                        {accountForm.troubleContactsMessageText[lang]}{' '}
                        <a onClick={(e) => { e.preventDefault(); toggleExpand(); }}>{accountForm.troubleContactsMessageLink[lang]}</a>
                    </p>
        }
        <div className={`${styles.expandableContent} ${isExpanded ? styles.expanded : ''}`}>
            <a target="_blank" className={styles.expand_item} href={INSTANCE === 'ala' ?
                'tel:+77003571338' :
                INSTANCE === 'msk' ?
                    'tel:+74992888385' :
                    INSTANCE === 'second' ?
                        'tel:+79917792163' : ''}>
                <img src={PhoneIcon} alt="phone" />
                <span>{accountForm.toCall[lang]}</span>
            </a>
            <a target="_blank" className={styles.expand_item} href={INSTANCE === 'spb' ?
                'https://t.me/kinoarenda_kinemotor' :
                INSTANCE === 'msk' ?
                    'https://t.me/kino_rent' :
                    INSTANCE === 'second' ?
                        'https://t.me/second_rent' : ''}>
                <img src={TgIcon} alt="tg" />
                <span>{accountForm.writeTg[lang]}</span>
            </a>
            {/* <a className={styles.expand_item} href={INSTANCE === 'ala' ?
                '+77003571338' :
                INSTANCE === 'msk' ?
                    '+74992888385' :
                    INSTANCE === 'second' ?
                        '+79917792163' : ''}>
                <img src={WhatsappIcon} alt="whatsapp" />
                <span>Написать в WhatsApp</span>
            </a> */}
        </div>
    </>
}